<template>
    <div>
        <div v-html="answer">{{ answer }}</div>
    </div>
</template>

<script>
export default {
    name: "longtext-question",
    props: {
        question: {
            type: Object,
            required: true,
        },
    },
    computed: {
        answer() {
            let answer = this.question.answer;
            return answer ?? "-";
        },
    },
};
</script>